export const TESTFLIGHT_LINK = "https://testflight.apple.com/join/NMPDC3wT";
export const ANDROID_LINK = "https://play.google.com/store/apps/details?id=com.basedapp.basedsuperapp";
export const DISCORD_LINK = "https://discord.com/invite/basedapp";
export const TWITTER_LINK = "https://x.com/BasedAppHQ";
export const TELEGRAM_LINK = "https://t.me/basedappupdates";
export const LINKEDIN_LINK = "https://www.linkedin.com/company/basedapp/";
